import { DND_NEW_SECTION, DND_NEW_TRANSITION } from "pages/editor/lib/timeline";
import { useDragLayer } from "react-dnd";
import styled from "styled-components";

export function getDragPreviewStyles(props) {
    const {
        item: { previewDimensions },
        clientOffset,
        currentOffset,
        itemType
    } = props;

    if (!clientOffset || !currentOffset) {
        return {
            display: `none`
        };
    }

    let x, y;
    let width, height;

    if (previewDimensions) {
        width = previewDimensions.width;
        height = previewDimensions.height;
    }

    if (itemType === DND_NEW_SECTION) {
        x = currentOffset.x;
        y = currentOffset.y;
    }

    if (itemType === DND_NEW_TRANSITION) {
        x = clientOffset.x - width / 2;
        y = clientOffset.y - height / 2;
    }

    const transform = `translate3D(${x}px, ${y}px,0)`;

    return {
        transform,
        width,
        height
    };
}

const Wrapper = styled.div`
    position: fixed;
    pointer-events: none;
    z-index: 100000;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
`;

/**
 * @summary -
 * Responsible for rendering drag previewe for new sections and transitions.
 * Does not render anything if React DnD's monitor returns isDragging to be false, or if an unsupported itemType is being dragged.
 * @returns {React.Element|false}
 */
const DragLayer = () => {
    function supportedItemType(type) {
        return type === DND_NEW_SECTION || type === DND_NEW_TRANSITION;
    }
    const monitorProps = useDragLayer((monitor) => ({
        item: monitor.getItem(),
        itemType: monitor.getItemType(),
        clientOffset: monitor.getClientOffset(),
        currentOffset: monitor.getSourceClientOffset(),
        isDragging: monitor.isDragging()
    }));
    const { isDragging, itemType, item } = monitorProps;
    return (
        isDragging &&
        supportedItemType(itemType) && (
            <Wrapper data-testid="drag-preview">
                <div style={getDragPreviewStyles(monitorProps)}>
                    {item?.previewElement}
                </div>
            </Wrapper>
        )
    );
};

export default DragLayer;
